module.exports = __webpack_public_path__ + "static/media/ic-check1.91bace20.svg";